import { put, call } from 'redux-saga/effects';
import { rolePermissionsCreateAPI, rolePermissionsSearchAPI, rolePermissionsUpdateAPI } from 'src/api/RolePermissionsApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { ROLE_PERMISSIONS_ACTIONS } from '../actions/RolePermissionsActions';
import { toast } from 'react-toastify';
function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(rolePermissionsSearchAPI, {
            where: buildSearchWithNoCase({
                where,
                fullTextSearch,
            }),
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: ROLE_PERMISSIONS_ACTIONS.ROLE_PERMISSIONS_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: ROLE_PERMISSIONS_ACTIONS.ROLE_PERMISSIONS_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
}) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(rolePermissionsSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {
            
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }

        
        yield put({
            type: ROLE_PERMISSIONS_ACTIONS.ROLE_PERMISSIONS_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(rolePermissionsCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        }));
        toast("Permission added successfully !")
        
        yield put({
            type: ROLE_PERMISSIONS_ACTIONS.ROLE_PERMISSIONS_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: ROLE_PERMISSIONS_ACTIONS.ROLE_PERMISSIONS_UPSERT_ERROR,
        });
    }
}

function* update(rolePermissionsId, payload) {
    try {
        yield call(rolePermissionsUpdateAPI, {
            rolePermissionsId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));

        yield edit({ _id: rolePermissionsId });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: ROLE_PERMISSIONS_ACTIONS.ROLE_PERMISSIONS_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(ROLE_PERMISSIONS_ACTIONS.ROLE_PERMISSIONS_SEARCH, search),
    takeFirstSagaUtil(ROLE_PERMISSIONS_ACTIONS.ROLE_PERMISSIONS_UPSERT, upsert),
    takeFirstSagaUtil(ROLE_PERMISSIONS_ACTIONS.ROLE_PERMISSIONS_EDIT, edit),
];
